import React, { useState } from 'react';
import { ChevronLeftIcon, ListIcon, MapIcon, MapPinIcon, PlayIcon } from 'lucide-react';
import { MapView } from './MapView';
import { useAudioPlayer } from '../context/AudioPlayerContext';
export function LocationExplorer({
  landmark,
  currentLocationIndex,
  setCurrentLocationIndex,
  onBack
}) {
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'map'
  const {
    setCurrentTrack,
    isPlaying,
    togglePlayPause
  } = useAudioPlayer();
  const locations = landmark.locations;
  const handleLocationSelect = index => {
    setCurrentLocationIndex(index);
    setCurrentTrack({
      title: locations[index].name,
      subtitle: landmark.name,
      speaker: locations[index].speaker,
      audioSrc: locations[index].audioSrc,
      imageSrc: locations[index].imageUrl,
      transcript: locations[index].transcript
    });
  };
  const handleNext = () => {
    if (currentLocationIndex < locations.length - 1) {
      handleLocationSelect(currentLocationIndex + 1);
    }
  };
  const handlePrevious = () => {
    if (currentLocationIndex > 0) {
      handleLocationSelect(currentLocationIndex - 1);
    }
  };
  return <div className="h-full flex flex-col" data-id="element-66">
      <div className="p-4 border-b flex items-center justify-between" data-id="element-67">
        <div className="flex items-center" data-id="element-68">
          <button onClick={onBack} className="mr-3 p-2 hover:bg-gray-100 rounded-full" data-id="element-69">
            <ChevronLeftIcon className="h-5 w-5 text-gray-600" data-id="element-70" />
          </button>
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-71">
            {landmark.name}
          </h2>
        </div>
        <div className="bg-gray-100 rounded-lg p-1 flex" data-id="element-72">
          <button className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 ${viewMode === 'list' ? 'bg-white shadow-sm' : ''}`} onClick={() => setViewMode('list')} data-id="element-73">
            <ListIcon className="h-4 w-4" data-id="element-74" />
            <span className="text-sm" data-id="element-75">List</span>
          </button>
          <button className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 ${viewMode === 'map' ? 'bg-white shadow-sm' : ''}`} onClick={() => setViewMode('map')} data-id="element-76">
            <MapIcon className="h-4 w-4" data-id="element-77" />
            <span className="text-sm" data-id="element-78">Map</span>
          </button>
        </div>
      </div>
      {viewMode === 'list' ? <div className="flex-1 overflow-auto p-4" data-id="element-79">
          <div className="space-y-3" data-id="element-80">
            {locations.map((location, index) => <div key={location.id} className={`p-4 rounded-lg flex items-center gap-4 ${index === currentLocationIndex ? 'bg-blue-50 border border-blue-100' : 'bg-white border border-gray-100'}`} data-id="element-81">
                <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-sm font-medium text-gray-700" data-id="element-82">
                  {index + 1}
                </div>
                <div className="flex-1" data-id="element-83">
                  <h3 className="font-medium text-gray-800" data-id="element-84">{location.name}</h3>
                  <p className="text-sm text-gray-500" data-id="element-85">
                    {location.duration} • {location.speaker}
                  </p>
                </div>
                <button className="p-2 rounded-full bg-blue-500 text-white" onClick={() => handleLocationSelect(index)} data-id="element-86">
                  <PlayIcon className="h-5 w-5" data-id="element-87" />
                </button>
              </div>)}
          </div>
          <div className="mt-6 flex justify-between" data-id="element-88">
            <button className="px-4 py-2 border rounded-lg text-gray-600 disabled:opacity-50" onClick={handlePrevious} disabled={currentLocationIndex === 0} data-id="element-89">
              Previous
            </button>
            <button className="px-4 py-2 bg-blue-500 text-white rounded-lg disabled:opacity-50" onClick={handleNext} disabled={currentLocationIndex === locations.length - 1} data-id="element-90">
              Next
            </button>
          </div>
        </div> : <MapView locations={locations} currentLocationIndex={currentLocationIndex} onLocationSelect={handleLocationSelect} center={landmark.coordinates} data-id="element-91" />}
    </div>;
}